import React, { useState } from "react";
import { Input, Modal } from "antd";
function ReverseAwardModal({ reversing, saving, onSave, onCancel }) {
  const [reason, setReason] = useState("");
  return (
    <Modal
      title="Reverse reward award"
      open={!!reversing}
      confirmLoading={saving}
      onCancel={() => !saving && onCancel()}
      onOk={() => onSave({ reason })}
      okButtonProps={{
        danger: true,
        disabled: reason.trim().length < 5,
      }}
    >
      <p>
        This reverses promotional value only. Already-spent rewards are
        recovered from future earning; purchased wallet funds are preserved.
      </p>
      <Input.TextArea
        value={reason}
        maxLength={180}
        onChange={(e) => setReason(e.target.value)}
        placeholder="Reason shown to the student"
      />
    </Modal>
  );
}
export default ReverseAwardModal;
